import { Dialog, styled } from "@mui/material"
import { backgroundColor, borderColor } from "src/sites/file/droparea/FileUploadItemTooltip"

interface ColoredDialogProps {
  color?: "warning" | "info" | "primary"
}

export const ColoredDialog = styled(Dialog)<ColoredDialogProps>(({ theme, color = "primary" }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: backgroundColor(color),
    border: color === "primary" ? "none" : "1px solid",
    borderColor: borderColor(color),
    maxWidth: "780px"
  },
  "& .MuiDialogTitle-root": {
    color: textColor(color),
    font: "normal normal 600 28px/41px Inter",
    letterSpacing: "0px",
    padding: theme.spacing(0, 2, 3, 0),
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap"
  },
  "& .MuiDialogTitle-root .MuiSvgIcon-root": {
    padding: theme.spacing(0, 1, 0, 0)
  },
  "& .MuiDialogContentText-root": {
    font: "normal normal 500 16px/24px Inter",
    letterSpacing: "0px",
    color: "#01294E"
  }
}))

export const textColor = (color: "warning" | "info" | "primary") => {
  switch (color) {
    case "warning":
      return "#EE9C3C"
    case "info":
      return "#555657"
    default:
      return "primary"
  }
}

